import React, { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import {
  fetchBlogComments,
  updateCommentStatus,
} from "../../services/axios/apiManager";
import DashboardLayout from "../DashboardLayout";
import LoadingSpinner from "../../Components/spinner";
import { FaEye } from "react-icons/fa";
import { toast } from "sonner";
import { format } from "date-fns";
import $ from "jquery";
import BlogCommentDetails from "./blogCommentDetails";
// import "datatables.net-bs5";

const BlogComments = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedComment, setSelectedComment] = useState({});
  //   const tableRef = useRef(null);

  const fetchComments = async () => {
    setLoading(true);
    try {
      const response = await fetchBlogComments(id);
      if (response?.data?.success) {
        setComments(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching comments:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchComments();
  }, [id]);

  const handleUpdateStatus = async (id, status) => {
    try {
      const response = await updateCommentStatus({ id, status: status ? 1 : 0 });
      if (response?.data?.success) {
        toast.success(response.data.message || "Status updated");
        fetchComments();
      }
    } catch (error) {
      console.error("Error updating comment status:", error);
    }
  };

  const closeDetails = () => {
    setSelectedComment({});
    setShowDetailsModal(false);
  };

  return (
    <DashboardLayout>
      <div className="container text-light bg-dark rounded mb-4 p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3>Blog Comments Moderation</h3>
          <Button
            variant="secondary"
            onClick={() => navigate("/BlogsManagement")}
          >
            Back to Blogs
          </Button>
        </div>

        <div className="position-relative">
          {loading && (
            <div
              className="position-absolute top-50 start-50 translate-middle"
              style={{ zIndex: 10 }}
            >
              <LoadingSpinner size="lg" />
            </div>
          )}
          <div className="table-responsive mt-2">
            {comments?.length > 0 ? (
              <Table className="table-hover table-striped align-middle table-borderless table-dark">
                <thead>
                  <tr>
                    <th>Content</th>
                    <th>Posted By</th>
                    <th>Email</th>
                    <th>Posted At</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {comments.map((comment) => (
                    <tr
                      key={comment?.id}
                      data-testid={`unit-row-${comment?.id || 1}`}
                    >
                      <td
                        title={comment?.content}
                        style={{
                          maxWidth: "200px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {comment?.content}
                      </td>
                      <td title="Commentor name">{`${comment?.user?.first_name} ${comment?.user?.last_name}`}</td>
                      <td title="Commentor email">{comment?.user?.email}</td>
                      <td title="Date Posted">
                        {format(comment?.createdAt, "PP")}
                      </td>
                      <td title="Change Status">
                        <button
                          className={`btn btn-link p-0 m-0 border-0 ${comment?.status ? "text-success" : "text-warning"
                            }`}
                          onClick={() => {
                            handleUpdateStatus(comment.id, !comment.status);
                          }}
                          style={{ textDecoration: "none" }}
                          title="change status"
                          data-testid={`status-button-${comment?.id || 1}`}
                        >
                          {comment?.status ? "Approved" : "Pending"}
                        </button>
                      </td>
                      <td>
                        <Button
                          variant="outline-success"
                          size="sm"
                          onClick={() => {
                            setSelectedComment(comment);
                            setShowDetailsModal(true);
                          }}
                          title="view details"
                        >
                          <FaEye />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <div className="d-flex justify-content-center">
                <span className="text-light">
                  No comments found for this blog
                </span>
              </div>
            )}
          </div>
        </div>
        <BlogCommentDetails
          showDetailsModal={showDetailsModal}
          selectedComment={selectedComment}
          closeDetails={closeDetails}
          fetchComments={fetchComments}
        />
      </div>
    </DashboardLayout>
  );
};

export default BlogComments;
